(ns ui.data.tenant.sub
  (:require [common.schema.registry :as registry]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::tenant
 (fn [db]
   (get db ::tenant)))

(rf/reg-sub
 ::tenant-product-plan
 :<-
 [::tenant]
 (fn [tenant _]
   (:tenant/product-plan tenant)))

(rf/reg-sub
 ::tenant-modules
 :<-
 [::tenant]
 (fn [tenant _]
   (:tenant/modules tenant)))

(rf/reg-sub
 ::tenant-custom-field-definitions
 :<-
 [::tenant]
 (fn [tenant _]
   (js/console.log "Recalc tenant custom field definitions")
   (:tenant/custom-field-definitions tenant)))

(rf/reg-sub
 ::tenant-schema
 :<-
 [::tenant-custom-field-definitions]
 (fn [tenant-custom-field-definitions _]
   (js/console.log "Recalc tenant schema")
   (registry/cross-entity-schema {:tenant/custom-field-definitions tenant-custom-field-definitions})))

(rf/reg-sub
 ::tenant-entity-schemas
 :<-
 [::tenant-schema]
 (fn [tenant-schema _]
   (js/console.log "Recalc tenant entity schemas")
   (->> registry/ordered-schemas
        (map (fn [[entity-type _]]
               [entity-type (registry/get-schema tenant-schema entity-type)]))
        (into {}))))

(rf/reg-sub
 ::entity-schema
 :<-
 [::tenant-entity-schemas]
 (fn [tenant-entity-schemas [_ entity-type]]
   (get tenant-entity-schemas entity-type)))


